(() => {
  // Synchronise la référence logistique "Boite Trio" (BOITE968_19179) avec les
  // coffrets Easy Bundle présents dans le panier : 1 boîte par coffret de 3 paires.
  // La ligne est masquée dans le panier mais reste sur la commande pour Ekan.
  const ArchCart = window.ArchCart;
  if (!ArchCart) {
    console.warn('[archiduchesse] ArchCart indisponible : réconciliation coffret non chargée.');
    return;
  }

  const BOX_VARIANT_ID = 40315888894151;
  const BOX_SKU = 'BOITE968_19179';
  const BOX_LINE_PROPERTY = '_archiduchesseBoxRef';
  let cartCoffretRelevant = null;

  const pairCount = (() => {
    try {
      const element = document.getElementById('arch-hidden-logistics');
      const parsed = JSON.parse((element && element.textContent) || '{}');
      const configuredCount = Number(parsed.pairCount);
      return Number.isFinite(configuredCount) && configuredCount > 0 ? configuredCount : 3;
    } catch (error) {
      return 3;
    }
  })();

  const countTrioBundles = (cart) => {
    const pairsPerBox = {};

    (Array.isArray(cart.items) ? cart.items : []).forEach((item) => {
      if (!item || item.variant_id === BOX_VARIANT_ID) return;

      const properties = item.properties || {};
      const boxId = properties['Box ID'];
      if (boxId == null || boxId === '') return;

      const quantity = Number(item.quantity);
      pairsPerBox[boxId] = (pairsPerBox[boxId] || 0) + (Number.isFinite(quantity) ? quantity : 0);
    });

    return Object.values(pairsPerBox).reduce(
      (boxes, pairs) => boxes + Math.floor(pairs / pairCount),
      0
    );
  };

  const isCoffretRelevant = (cart) => (Array.isArray(cart.items) ? cart.items : []).some((item) => {
    if (!item) return false;
    if (item.variant_id === BOX_VARIANT_ID) return true;
    const properties = item.properties || {};
    const boxId = properties['Box ID'];
    return boxId != null && boxId !== '';
  });

  const syncBoxWithCart = () => ArchCart.fetchCart().then((cart) => {
    if (!cart) return null;

    cartCoffretRelevant = isCoffretRelevant(cart);

    const neededBoxes = countTrioBundles(cart);
    const boxLine = (Array.isArray(cart.items) ? cart.items : [])
      .find((item) => item && item.variant_id === BOX_VARIANT_ID);
    const currentBoxes = boxLine ? Number(boxLine.quantity) : 0;

    if (neededBoxes === currentBoxes) return null;

    if (!boxLine) {
      const properties = {};
      properties[BOX_LINE_PROPERTY] = BOX_SKU;
      return ArchCart.cartRequest('/cart/add.js', {
        items: [{ id: BOX_VARIANT_ID, quantity: neededBoxes, properties }]
      }, BOX_SKU);
    }

    return ArchCart.cartRequest(
      '/cart/change.js',
      { id: boxLine.key, quantity: neededBoxes },
      BOX_SKU
    );
  });

  const reconciler = ArchCart.createReconciler({
    name: 'boîte coffret',
    source: 'arch-coffret-box',
    task: syncBoxWithCart
  });

  ArchCart.onCartMutation(() => {
    cartCoffretRelevant = null;
    reconciler.trigger();
  });
  ArchCart.onBeforeCheckout(() => {
    if (cartCoffretRelevant === false) return null;
    return reconciler.flush();
  });

  // L'app Easy Bundle déclenche cet événement après l'ajout d'un coffret. Les
  // lignes peuvent arriver avec un léger différé, d'où six vérifications bornées.
  document.addEventListener('gbb-checkout-success', () => {
    cartCoffretRelevant = null;
    let attempts = 0;

    const tick = () => {
      attempts += 1;
      reconciler.trigger(0);
      if (attempts < 6) window.setTimeout(tick, 1200);
    };

    window.setTimeout(tick, 700);
  });

  if (/(^|;\s*)cart=/.test(document.cookie)) reconciler.trigger(900);
})();
